import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SecurityService } from './security.service';
import { Token } from './models/token.model';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Injectable()
export class GlobalInterceptor implements HttpInterceptor {
  constructor(private toastrService: ToastrService,
    private securityService: SecurityService,
    private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token: Token = this.securityService.getToken();
    if (token) {
      request = request.clone({
        headers: request.headers.set('Authorization', 'Bearer ' + token.token)
      });
    }

    if (!request.headers.has('Content-type')) {
      if (!(request.body instanceof FormData)) {
        request = request.clone({
          headers: request.headers.set('Content-type', 'application/json')
            .set('Pragma', 'no-cache')
        });
      }
    }
    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {
        },
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            switch (err.status) {
              case 500:
                this.toastrService.error('couldn\'t complete action', 'server error');
                break;
              case 400:
                this.toastrService.error(err.error.technicalErrorMessage, err.error.errorMessage);
                break;
              case 401:
                this.securityService.logout();
                break;
              case 403:
                this.toastrService.error('You are not authorized to access resource');
                break;
              case 404:
                this.router.navigateByUrl('/**');
                break;
              default:
                console.error(`
                  returned code ${err.status},
                   `);
                break;
            }
          }
        }
      )
    );
  }
}
